import { IOfferState } from '../../../redux/reducers/offer';

interface IRosreestrElement {
  title: string;
  value: string;
}

interface IRosreestrPart {
  header: string;
  elements: IRosreestrElement[];
}

export interface IRosreestrCard {
  parts: IRosreestrPart[];
}

export enum ECadastralFieldsNames {
  CadastralNumber = 'cadastralNumber',
  BuildingCadastralNumber = 'buildingCadastralNumber',
}

export enum EResponseStatus {
  Initial = 'initial',
  Success = 'success',
  Error = 'error',
}

export interface ICadastralFieldMeta {
  errors: IErrors;
  checkedValue?: string;
  isChecking: boolean;
  isRequired: boolean;
}

export interface ICadastralFieldError {
  type: EErrorType;
  text: string;
}

export interface ICadastralField {
  value: string;
  error?: ICadastralFieldError;
  isChecked: boolean;
  isChecking: boolean;
  isRequired: boolean;
}

export type TServerErrors = Partial<Record<ECadastralFieldsNames, string | null>>;

export enum EErrorType {
  ValidationError = 'validationError',
  NotFoundError = 'notFoundError',
  RequiredError = 'requiredError',
}

interface IErrorData<T> {
  value: T;
  message: string;
}

export interface IErrors {
  [EErrorType.ValidationError]: IErrorData<string>;
  [EErrorType.NotFoundError]?: IErrorData<string>;
  [EErrorType.RequiredError]: IErrorData<boolean>;
}

export type TAddress = Partial<Record<ECadastralFieldsNames, string | null>>;

export interface IRosreestrData {
  address: TAddress;
  cardView: IRosreestrCard;
}

export interface IRosreestrDataState {
  address?: TAddress | null;
  autofields: Pick<IOfferState, 'building' | 'isDacha' | 'totalArea' | 'land'>;
  cardView?: IRosreestrCard | null;
  cadastralFieldsMeta: Record<ECadastralFieldsNames, ICadastralFieldMeta>;
  responseStatus: EResponseStatus;
}
